const NFL_ESPN_LOGO_IDS = {
  WAS: "wsh",
};

export function getNflLogoId(franchiseId) {
  const id = String(franchiseId || "").toUpperCase();
  if (!id) return null;
  return NFL_ESPN_LOGO_IDS[id] || id.toLowerCase();
}

export function getNflTeamLogoUrl(franchiseId) {
  const logoId = getNflLogoId(franchiseId);
  if (!logoId) return null;
  return `https://a.espncdn.com/i/teamlogos/nfl/500/${logoId}.png`;
}
